/**
 * @desc: iot服务
 */
const Api = require('../../api/index');
const FetchService = require('../../api/base.fetch').default;
const Util = require('../../../util/index');
export const Iot = {
    id: 'iot',
    // 获取服务用的 Key
    getServiceKey: (name, option) => {
        return new Promise((resolve) => {
            let token = Api.UserService.accesstoken(name, option);
            resolve(token);
        });
    },
    // 获取服务地址
    getDomain: (type) => {
        return new Promise((resolve) => {
            let domain = '';
            if (type === 'cloudList') {
                domain = Util.translateRequestUrlForEU(FetchService.domainconfig.iot);
            }
            else if (type === 'weather') {
                domain = Util.translateRequestUrlForEU(FetchService.domainconfig.weather);
            }
            else if (type === 'air') {
                domain = Util.translateRequestUrlForEU(FetchService.domainconfig.air);
            }
            resolve(domain);
        });
    }
};
